import { LoaderFunctionArgs, Outlet } from 'react-router-dom'
import { userPreferencesPort } from '@/infra/config/beans'
import TopBar from '@/src/components/layout/top-bar/TopBar'
import { runUserPreferencesGuard } from '@/src/router/guards/runUserPreferenceGuard'
import { useState } from 'react'

export const Loader = ({ request }: LoaderFunctionArgs) => {
  const currentPath = new URL(request.url).pathname
  return runUserPreferencesGuard(userPreferencesPort, currentPath)
}

const RootLayout = () => {
  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')
  return (
    <div className="h-dvh flex flex-col">
      <TopBar variant="dark" title={title} subtitle={subTitle || undefined} />
      <main className="flex-1 overflow-auto scroll-mb-4 bg-primary-blue pt-2">
        <Outlet context={{ setTitle, setSubTitle }} />
      </main>
    </div>
  )
}

export default RootLayout
